import { render } from "./Payment.vue?vue&type=template&id=2fe94281"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import "./Payment.vue?vue&type=style&index=0&id=2fe94281&lang=css"
script.render = render

export default script